export function isUserRecruiter(user) {
  return user?._organizations && user._organizations.length > 0;
}
